import {Component, forwardRef, Host} from "@angular/core";
import {SearchAction, SearchActionSelector} from "../../entity/search/search-grid/actions/search-action.component";
import {EntityModel, SearchModel} from "@fedeltapointofsale/data-client";
import {ActionsSearchColumnComponent} from "../../entity/search/search-grid/columns/actions-search-column.component";
import {SearchActionEvent} from "../../entity/search/search-page/search-action-event";

/**
 * SearchAction to add a record from the grid.
 */
@Component({
    selector: "wbo-add-search-action",
    template: "",
    providers: [
        {provide: SearchActionSelector, useExisting: forwardRef(() => AddSearchActionComponent), multi: true}
    ]
})
export class AddSearchActionComponent implements SearchAction {

    static readonly ADD_NAME: string = "wbo.common.button.add";
    static readonly ADD_ICON: string = "plus";

    static readonly IMPORTANCE: number = 50;

    private available: boolean = false;

    constructor(@Host() private parent: ActionsSearchColumnComponent, private searchModel: SearchModel<any>, private entityModel: EntityModel<any>) {
        this.entityModel.canCreateEntity().then((canCreate: boolean) => this.available = canCreate);
    }

    getImportance(): number {
        return AddSearchActionComponent.IMPORTANCE;
    }

    getIcon(data: any): string {
        return AddSearchActionComponent.ADD_ICON;
    }

    getIconClass(data: any): string {
        return "";
    }

    getIconSize(data: any): number {
        return 17;
    }

    getName(data: any): string {
        return AddSearchActionComponent.ADD_NAME;
    }

    doAction(data: any): Promise<void> {
        const dataKey: any = {[this.searchModel.getIdentifierField()]: this.searchModel.getIdentifier(data)};
        this.parent.emitItemAction(new SearchActionEvent(SearchActionEvent.ACTION_ADD_FROM_RECORD, dataKey));
        return null;
    }

    isAvailable(data: any): boolean {
        return this.available;
    }
}
